import React from "react";
import { DividerLine } from "./DividerElements";

const Divider = () => {
  return <DividerLine />;
};

export default Divider;
